export const BOOKING_ACTIVITY = "Booking your activity";
export const SAVING_TRAVELERS_AND_CHECKING_AVAILABILITY =
  "Saving travelers and checking availability";
